// extracted by mini-css-extract-plugin
export var productImage = "_pn-1";
export var viewLink = "_pn-2";
export var wishlistItem = "_pn-0";